<template>
<div>
  <div>
     <section class="time-line-box">
          <div class="swiper-container text-center"> 
                <div class="swiper-wrapper">
                    <div class="swiper-slide" id="swiper-slide-first">
                      <div class="timestamp" >
                         <div  id="order_label" ><span class="count-detail" @click="ShowOutlinerKits(11,-1,'processing',)"><span class="count">{{ report.ordered}}</span><br>Ordered</span></div>
                         <div  id="shipped_label"><span class="count-detail" @click="ShowOutlinerKits(0,0,'shipped')" ><span class="count">{{ report.shipped }}</span><br>Shipped</span></div>
                      </div>
                      <div class="title" id="order" ><span></span></div>
                      <div class="title" id="shipped" ><span></span></div>
                    </div>
                </div>
                <div class="swiper-wrapper">
                    <div class="swiper-slide" >
                      <div class="timestamp" id="delivered_label"><span @click="ShowOutlinerKits(0,7,'delivered')"  class="count-detail"><span class="count">{{ report.delivered }}</span><br>Delivered</span></div>
                      <div class="title" id="delivered"><span></span></div>
                    </div>
                </div>
                <div class="swiper-wrapper">
                    <div class="swiper-slide" >
                      <div class="timestamp" id="activated_label"><span @click="ShowOutlinerKits(0,1,'activated')" class="count-detail"><span class="count">{{ report.activated }}</span><br>Activated</span></div>
                     <div class="title" id="activated"><span></span></div>
                    </div>
                </div>
                  <div class="swiper-wrapper">
                    <div class="swiper-slide" >
                      <div class="timestamp" id="submitted_label"><span @click="ShowOutlinerKits(0,2,'awaiting')" class="count-detail"><span class="count">{{ report.lab_awaiting }}</span><br>Submitted</span></div>
                     <div class="title" id="submitted"><span></span></div>
                    </div>
                </div>
                 <div class="swiper-wrapper">
                    <div class="swiper-slide" >
                      <div class="timestamp" id="received_label"><span @click="ShowOutlinerKits(0,3,'received')" class="count-detail"><span class="count">{{ report.lab_received }}</span><br>Received</span></div>
                      <div class="title" id="received"><span></span></div>
                    </div>
                </div>
                 <div class="swiper-wrapper">
                    <div class="swiper-slide" id="swiper-slide-last">
                      <div class="timestamp" id="completed_label"><span @click="ShowOutlinerKits(0,5,'complete')" class="count-detail"><span class="count">{{ report.analysis_completed }}</span><br>Completed</span></div>
                     <div class="title" id="completed"><span></span></div>
                    </div>
                </div>
                <div class="swiper-pagination"></div>
            </div>
       </section>
  </div>
</div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "LiveOrderTimeline",
  data() {
    return {
      report: {
        activated: 0,
        analysis_completed: 0,
        lab_received: 0,
        lab_awaiting: 0,
        on_hold: 0,
        shipped: 0,
        total: 0,
        delivered:0,
        ordered:0
      }
    };
  },
  computed: {
    ...mapGetters(["getTimelineStatus"])
  },
  watch: {
    getTimelineStatus(obj) {
      for (var k in obj) {
        if (this.report.hasOwnProperty(k)) {
          this.report[k] = Number(obj[k]);
        }
      }
    }
  },
  methods: {
    ...mapActions([
        "setProblemFilter",
        "sendSearchReq",
        "setComponentNum",
        "getWooOrders",
        "changeDashboardValues"
    ]),
    mouseOver(model) {
      let node = document.getElementsByClassName(model)[0];
      node.style.opacity = "1";
    },
    mouseLeave(model) {
      let className = `${model} opacity`;
      let node = document.getElementsByClassName(className)[0];
      node.style.opacity = "0";
    },
    ShowOutlinerKits(steps,status,value)
    {
      this.changeDashboardValues();
      if(steps == 0) {
        // this.sendSearchReq();
        this.$emit("switchOrder",{ steps: steps,value: value});
      } else {
        this.getWooOrders();
        this.$emit("switchOrder",{ steps: steps,value: value});
      }
    }
  },
  async mounted(){
    for (var k in this.$store.getters.getTimelineStatus) {
        if (this.report.hasOwnProperty(k)) {
          this.report[k] = Number(this.$store.getters.getTimelineStatus[k]);
        }
    }
  }
};
</script>
<style scoped lang="scss">
@import "../../../styles/colors";
.col-6{
  width: 50%;
}
.date{
  height: 20px;
}
.time-line-box {
  width: 100%;
}
.time-line-box  .title{
  font-family: TTNormsMedium, sans-serif;
}

.time-line-box .swiper-container {
  display: flex;
  justify-content: center;
}

.time-line-box .timestamp {
  margin: auto;
  margin-bottom: 9px;
  padding: 0px 4px;
  display: flex;
  align-items: center;
  font-family: TTNormsMedium, sans-serif;
  font-weight: 400;
}
.time-line-box .timestamp .count {
  font-weight: 600;
}

.swiper-container {
  width: 100%; 
  margin: auto;
}
.swiper-wrapper{
  height: 70px;
  display: inline-flex;
  flex-direction: row;
  justify-content: center;
}
.swiper-container::-webkit-scrollbar-track{
   background:#a8a8a8b6;
}
.swiper-container::-webkit-scrollbar{
  height: 2px;
}
.swiper-container::-webkit-scrollbar-thumb{
   background: #4F4F4F !important;
}
.swiper-slide {
  text-align: center;
  font-size: 12px;
   font-weight: 500;
  width: 165px;
  height: 100%;
  position: relative;
}
#swiper-slide-first {
  width: 167px;
}
#swiper-slide-last {
  width: 152px;
}
.text-center{
  text-align: left;
}
.swiper-slide .title span:before {
  content: '';
  width: 16px;
  height: 16px;
  border-radius: 16px;
  position: absolute;
  left: 50%;
  top: 35px;
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  transition: all 200ms ease-in;
  z-index: 1;
}
.swiper-slide #order span:before {
  background-color: $black;
  border: 2px solid $black;
  z-index: 0;
  left: 0% !important;
}
.swiper-slide #shipped span:before {
  background-color: $green;
  border: 2px solid $green;
  left: 96% !important;
}
.swiper-slide #delivered span:before {
  background-color: $blue;
  border: 2px solid  $blue;
  left: 96% !important;
}
.swiper-slide #activated span:before {
  background-color: $lightGray;
  border: 2px solid $lightGray;
  left: 96% !important;
}
.swiper-slide #submitted span:before {
  background-color: $yellow;
  border: 2px solid $yellow;
  left: 96% !important;
}
.swiper-slide #received span:before {
  background-color: $heather;
  border: 2px solid  $heather;
  left: 96% !important;
}
.swiper-slide #completed span:before {
  background-color: $caribbeanBlue;
  border: 2px solid  $caribbeanBlue;
  left: 96% !important;
}
.time-line-box #shipped {
  border-top: 6px solid  $green;
}

.time-line-box #delivered {
  border-top: 6px solid  $blue;
}

.time-line-box #activated {
  border-top: 6px solid $lightGray;
}

.time-line-box #submitted {
  border-top: 6px solid  $yellow;
}

.time-line-box #received {
  border-top: 6px solid  $heather;
}

.time-line-box #completed {
  border-top: 6px solid  $caribbeanBlue;
}

#order_label span {
    color: $black;
}
#order_label {
    margin-left: -16% !important;
}

#shipped_label span {
    color: $green;
}
#shipped_label{
    margin-left: 72% !important;
}
.count-detail{
  cursor: pointer;
}

#delivered_label .count-detail{
    color: $blue;
    margin-left: 83%;
}

#activated_label .count-detail{
    color: $lightGray;
    margin-left: 82%;
}

#submitted_label .count-detail{
    color: $yellow;
    margin-left: 82%;
}

#received_label .count-detail{
    color: $heather;
    margin-left: 82%;
}

#completed_label .count-detail{
    color: $caribbeanBlue;
    margin-left: 80%;
}
@media (max-width: 1175px) {
  .swiper-slide {
    font-size: 10px; /* Adjust font size for smaller screens */
    width: 125px; /* Adjust width to fit smaller screens */
  }

  #swiper-slide-first {
    width: 124px; /* Adjusted width for smaller screens */
  }

  #swiper-slide-last {
    width: 120px; /* Adjusted width for smaller screens */
  }
  .swiper-slide .title span:before {
    content: '';
    width: 13px;
    height: 13px;
    border-radius: 13px;
    position: absolute;
    left: 50%;
    top: 32px;
    -webkit-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    transition: all 200ms ease-in;
    z-index: 1;
  }
}
</style>